module.exports = __webpack_public_path__ + "img/ex-tasks_sm.c8dec539.png";